import React, { useEffect } from 'react';

type StudioToastProps = {
  message: string | null;
  onDismiss: () => void;
  durationMs?: number;
};

/** Lightweight in-app toast (no email). Auto-dismisses. */
const StudioToast: React.FC<StudioToastProps> = ({
  message,
  onDismiss,
  durationMs = 4500,
}) => {
  useEffect(() => {
    if (!message) return;
    const id = window.setTimeout(onDismiss, durationMs);
    return () => window.clearTimeout(id);
  }, [message, onDismiss, durationMs]);

  if (!message) return null;

  return (
    <div
      className="studio-toast"
      role="status"
      aria-live="polite"
      data-testid="studio-toast"
    >
      {message}
    </div>
  );
};

export default StudioToast;
